<template>
<div style="position: relative">
  <div
    v-click-outside="closeMenu"
    @keydown.esc="closeMenu"
    tabindex="0"
    class="action-btn la las la-ellipsis-v la-2x"
    @click.stop="openMenu(record_index)"
  >
  </div>
  <div
    :class="[
      'menu-list',
      (record_index === table_data.length - 1) || (record_index === table_data.length - 2) ? 'position-up' : ''
    ]"
    v-if="
    $store.state.open_menu_index === `${this.tableIndex}.${record_index}` &&
    actionList.length
    "
  >
    <div
      v-for="(action, index) in actionList"
      :key="index"
      @mouseenter="mouseenter(index)"
      @mouseleave="mouseleave"
      @click.stop="
        () => {
          action.click(record, record_index);
          closeMenu();
        }
      "
    >
    <div
      
      :class="[
      'menu-item',
      ]"
    >
      <i :class="action.icon_class"></i>
      {{ action.label }}
    </div>
    </div>
</div>
</div>
</template>

<script>

export default {
  name: "base-menu",
  props: [
      "table_data",
      "tableActions",
      "record",
      "record_index",
      "column",
      "tableIndex",
  ],
  data() {
    return {
      icon_hover_index: null,
      actionList: [],
    };
  },
  methods: {
    openMenu(index) {
      if (this.$store.state.open_menu_index === `${this.tableIndex}.${index}`) this.$store.state.open_menu_index = null;
      else this.$store.state.open_menu_index = `${this.tableIndex}.${index}`;
      this.actionList = this.tableActions.filter(action => action.shouldRender(this.record));
    },
    closeMenu() {
      this.$store.state.open_menu_index = null;
    },
    mouseenter(index) {
      this.icon_hover_index = `${this.tableIndex}.${index}`;
    },
    mouseleave() {
      this.icon_hover_index = null;
    },
  },
};
</script>

<style lang="scss">
@import './BaseMenu.scss';
</style>
